/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import Choice from './choiceType';

export const canadaProvinces: Choice[] = [
  { text: 'AB', value: 'AB' },
  { text: 'BC', value: 'BC' },
  { text: 'MB', value: 'MB' },
  { text: 'NB', value: 'NB' },
  { text: 'NL', value: 'NL' },
  { text: 'NS', value: 'NS' },
  { text: 'NT', value: 'NT' },
  { text: 'NU', value: 'NU' },
  { text: 'ON', value: 'ON' },
  { text: 'PE', value: 'PE' },
  { text: 'QC', value: 'QC' },
  { text: 'SK', value: 'SK' },
  { text: 'YT', value: 'YT' },
];
